<template>
	<v-layout row>
        <v-flex md2 class="pa-0">
            <sub-side-bar :items="settingsMenu">
              <div
                v-if = "currentApp && currentBot && currentBot.length"
                slot = "header"
                style = "padding: 5px 10px !important; margin-top: 10px !important">
                <router-link
                  to = "/nlp"
                  class = "text-bold primary--text text-lg nlp-app-main-title"
                  large
                  flat
                  :title="currentApp.name">
                  <v-icon class=  "primary--text" style = "line-height: 0.6;">west</v-icon>
                  {{ currentApp.name }}
                </router-link>
              </div>
            </sub-side-bar>
        </v-flex>
        <v-flex md10 v-if = "currentApp && currentBot && currentBot.length">
            <router-view/>
        </v-flex>
        <v-flex md10 v-else>
          <v-card v-if = "!currentBot || !currentBot.length" class = "card-curvey text-center headline text-bold">
            You Have To <router-link to = "/">Select Bot</router-link> first
          </v-card>
          <v-card v-if = "!currentApp && !$store.state.core.loader" class = "card-curvey text-center headline text-bold">
            You Have To <router-link :to = "`/nlp?from=${$route.name}`">Select App</router-link> first
          </v-card>
          <v-card v-if = "$store.state.core.loader" class = "card-curvey text-center headline text-bold">
            Loading...
          </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import subSideBar from "../../common/subSideBar";
export default {

  name: 'nlp-main',
  components: {
  	subSideBar
  },
  data () {
    return {
    	
    }
  },
  mounted() {
    // get the current app
    if (!this.currentApp) {
      this.$store.dispatch('nlp/apps/get/current', this.$route.params.id)
    }
  },
  computed: {
  	currentApp() {
  		return this.$store.state.nlp.selectedApp
  	},
    currentBot() {
      return this.$store.state.bot.botId
    },
  	settingsMenu() {
  		if (!this.currentApp) return {}
  		return {
                    title: 'App',
                    menu: [
                        {
                            title: 'App Assets',
                            items: [
                                {
                                    title: 'Intents',
                                    link: `/nlp/app/${this.currentApp.id}/intents`
                                },
                                {
                                    title: 'Entities',
                                    link: `/nlp/app/${this.currentApp.id}/entities`
                                },
                                // {
                                //     title: 'Unknown Utterances',
                                //     link: `/nlp/app/${this.currentApp.id}/unknown-terms`
                                // }
                            ],
                        },
                        // {
                        //     title: 'App Analytics',
                        //     items: [
                        //         {
                        //             title: 'Reports',
                        //             link: `/nlp/app/${this.currentApp.id}/reports`
                        //         }
                        //     ],
                        // },
                        {
                            title: 'Settings',
                            items: [
                                {
                                    title: 'App Versions',
                                    link: `/nlp/app/${this.currentApp.id}/versions`
                                },
                                {
                                    title: 'Configure Keys',
                                    link: `/nlp/app/${this.currentApp.id}/keys`
                                }
                            ],
                        }
                    ]
                }
  		
  	}
  }
}
</script>

<style lang="css" scoped>
.nlp-app-main-title {
  text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
  
}
</style>